module.exports = __webpack_public_path__ + "img/card-media.5c0b4a95.png";